import _extends from "@babel/runtime/helpers/extends";
import React, { useContext } from 'react';
import Loadable from 'react-loadable';
import { CardLoading } from '../utils/lightCards/cardLoading';
import UFOSegment from '@atlaskit/react-ufo/segment';
var MediaCardContext = /*#__PURE__*/React.createContext({});
var CardLoadingWithContext = function CardLoadingWithContext() {
  var props = useContext(MediaCardContext);
  return /*#__PURE__*/React.createElement(CardLoading, _extends({}, props, {
    interactionName: "media-card-async-loading"
  }));
};
var MediaCardWithMediaClientProvider = Loadable({
  loader: function loader() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-card-with-media-client" */'./cardWithMediaClient').then(function (mod) {
      return mod.CardWithMediaClient;
    });
  },
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CardLoadingWithContext, null);
  }
});
var CardLoader = function CardLoader(props) {
  return /*#__PURE__*/React.createElement(UFOSegment, {
    name: "media-card",
    mode: "list"
  }, /*#__PURE__*/React.createElement(MediaCardContext.Provider, {
    value: props
  }, /*#__PURE__*/React.createElement(MediaCardWithMediaClientProvider, props)));
};
CardLoader.preload = function () {
  return MediaCardWithMediaClientProvider.preload();
};
export default CardLoader;